import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

import { FetchInstallationsNetworkMetricsReqData } from "./FetchInstallationsNetworkMetricsCommand";
import { GetNetworkMetricsTotalResData } from "./GetNetworkMetricsTotalResData";
const ENDPOINT = "/network_metrics/total";

export class GetNetworkMetricsTotalCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsNetworkMetricsReqData;

    constructor(payload: FetchInstallationsNetworkMetricsReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetNetworkMetricsTotalResData> {
        var res = await this.executeCommand(this.payload);
        return new GetNetworkMetricsTotalResData(res);
    }
}
